module.exports = __webpack_public_path__ + "static/media/default-box.6b25c655.png";